import { token } from '@atlaskit/tokens';
import styled from 'styled-components';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ShowMoreButtonWrapper = styled.div({
  display: 'flex',
  justifyContent: 'center',
  margin: token('space.250'),
});
